parasails.registerPage('viewevents', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    //…
    newEvent: {},
    newEventModalVisible: false,
    addEventFormData: {
      title: ''
    },
    virtualPageSlug: '',
    confirmDeleteEventModal: false,
    syncing: false,
    formErrors: { /* … */ },
    cloudError: '',
    selectedEventID: undefined,
  },

  virtualPages: true,
  html5HistoryMode: 'history',
  virtualPagesRegExp: /^\/events\/?([^\/]+)?/,

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
  },

  mounted: async function() {
    //…
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {

    addEvent: function() {
      //this.goto('/events/new');
      this.newEventModalVisible = true;
    },

    closeAddEventModal: function() {
      this._clearAddEventModal();
    },

    selectEvent: async function(eventID) {
      console.log('Clicked Event ' + eventID);
    },

    manageEvent: async function(eventID) {
      this.goto('/manageevent?eventID=' + eventID);
    },

    editEvent: async function(eventID) {
      this.goto('/editevent?eventID=' + eventID);
    },

    deleteEvent: async function(eventID) {
      console.log('Deleting Event ' + eventID);
      this.selectedEventID = eventID;
      this.confirmDeleteEventModal = true;
    },

    closeDeleteEventgModal: function() {
      this.selectedEvent = undefined;
      this.confirmDeleteEventModal = false;
      this.cloudError = '';
    },

    submittedAddEventForm: async function(result) {
      if(this.addEventFormData.title === '') {return;}

      try {
        //await Cloud.create.with({title: this.addEventFormData.title});
        this.newEvent = await Cloud.createevent.with({title: this.addEventFormData.title});
      } catch (error) {
        console.log('Error saveing data: ' + error);
      }

      this.selectedEventID = this.newEvent.newEvent.id;
      // Add the new event to the list
      this.events.unshift(this.newEvent.newEvent);

      // Close the modal.
      this._clearAddEventModal();
    },

    submittedDeleteEventForm: async function() {
      //await Cloud.delete.with({ id: this.selectedEventID });
      _.remove(this.events, { id: this.selectedEventID });
      this.$forceUpdate();

      // Close the modal.
      this.confirmDeleteEventModal = false;
    },

    handleParsingAddEventForm: function() {
      // Clear out any pre-existing error messages.
      this.formErrors = {};

      var argins = this.addEventFormData;

      // If there were any issues, they've already now been communicated to the user,
      // so simply return undefined.  (This signifies that the submission should be
      // cancelled.)
      if (Object.keys(this.formErrors).length > 0) {
        return;
      }

      return _.omit(argins, []);
    },

    handleParsingDeleteEventForm: function() {
      return {
        id: this.selectedEventID
      };
    },

    _clearAddEventModal: function() {
      this.newEventModalVisible = false;
      // Close modal -- Event ID is undefined here. Fix that...
      //this.goto('/events');
      this.selectedEventID = undefined;
      // Reset form data
      this.addEventFormData = {
        title: ''
      };
      // Clear error states
      this.formErrors = {};
      this.cloudError = '';
    },
  }
});
